import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';

const validate = (draft, { allowSelectRecipients }) => {
    let errors = {};

    if (allowSelectRecipients && (!draft.recipients || draft.recipients.trim() === '')) {
        errors.recipients = "This field is required";
    }

    if (!draft.subject || draft.subject.trim() === '') {
        errors.subject = "This field is required";
    }

    if (!draft.message || draft.message.trim() === '') {
        errors.message = "This field is required";
    }
    return errors;
};

class BulkEmailDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
    }

    render() {
        const dialogProps = {
            title:          this.props.title,
            open:           true,
            modal:          true,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="submit" label="Send" onTouchTap={this.onSave} disabled={!this.state.isValid} />
            ]
        };

        return (
            <Dialog {...dialogProps} >
                {!this.props.allowSelectRecipients
                    ? (<div>Recipients: <span>{this.state.draft.users.map(user => user.name).join('; ')}</span></div>)
                    : (
                        <TextField
                            name="recipients"
                            value={this.state.draft.recipients}
                            errorText={this.state.errors.recipients}
                            hintText="To"
                            floatingLabelText="To"
                            onChange={this.onTextChange}
                            fullWidth={true}
                        />
                    )
                }
                <TextField
                    name="subject"
                    floatingLabelText="Subject"
                    value={this.state.draft.subject}
                    errorText={this.state.errors.subject}
                    onChange={this.onTextChange}
                    fullWidth={true}
                />
                <TextField
                    name="message"
                    floatingLabelText="Message"
                    value={this.state.draft.message}
                    errorText={this.state.errors.message}
                    onChange={this.onTextChange}
                    fullWidth={true}
                    multiLine={true}
                    rows={4}
                />
                {this.props.children}
            </Dialog>
        );
    }

    onTextChange({target}) {
        if (!target.name) { return; } //guard
        DialogActions.updateDraft(target.name, target.value);
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

BulkEmailDialog.getStores = () => ([DialogStore]);
BulkEmailDialog.calculateState = (prevState, props) => {
    const {open, draft} = DialogStore.getState();
    const errors = validate(draft, props);
    return {
        open,
        draft,
        errors,
        isValid: (Object.keys(errors).length === 0),
    };
};
BulkEmailDialog.propTypes = {
    title:          PropTypes.string,
    userList:       PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number,
            name:   PropTypes.string
        })
    ),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool,
    allowSelectRecipients: PropTypes.bool

};

BulkEmailDialog.defaultProps = {
    title:          "Send message",
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true,
    allowSelectRecipients: false
};

export default Container.create(BulkEmailDialog, {withProps: true});
